<template>
  <VView class="home">
    <VText center>{{ $t('home.content') }}</VText>

    <VBlock max-width="300px">
      <transition name="bounceUp" appear>
        <VButton to="/menu">{{ $t('home.button') }}</VButton>
      </transition>
    </VBlock>
  </VView>
</template>

<script>
export default {
  name: 'Home',
};
</script>

<style lang="scss" scoped>
.home {}
</style>
